import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import billUnpaid from '@/assets/images/billUnpaid.png';
import { useBrowserUserId } from '@/hooks/useBrowserUserId';
import {
  getFailedPaymentsCount,
  getPaymentProcessLatency,
  getPaymentTimestamps,
  getSystemInfo,
  sendBusinessEvent,
  setPaymentEndTimestamp,
} from '@/screens/Checkout/monitoring';
import styles from './PaymentFailure.module.scss';

const PaymentFailure = () => {
  const { t } = useTranslation();
  const browserUserId = useBrowserUserId();
  const urlParams = new URLSearchParams(window.location.search);
  const message = urlParams.get('message') || '';
  const errorCode = urlParams.get('errorCode') || 'unknown';
  const paymentMethod = urlParams.get('paymentMethod') || 'unknown';
  const order = urlParams.get('order') || '';
  const orderId = urlParams.get('orderId') || '';
  const orderValue = urlParams.get('orderValue') || '';
  const brand = urlParams.get('brand') || '';
  const splitBillEnabled = urlParams.get('splitBillEnabled') || '';
  const numberOfSplits = urlParams.get('numberOfSplits') || '';
  const payingFor = urlParams.get('payingFor') || '';
  const splitType = urlParams.get('splitType') || '';
  const serviceFeeAmount = urlParams.get('serviceFeeAmount') || '';

  useEffect(() => {
    // Set payment end timestamp when user sees the failure page
    setPaymentEndTimestamp();
  }, []);

  // Send screen viewed business event
  useEffect(() => {
    sendBusinessEvent('kitopay.screen.viewed', {
      screen: 'payment_failure',
      orderId: orderId || order,
    });
  }, [orderId, order]);

  useEffect(() => {
    // Send detailed failure event only once
    // Note: Using 'purchase_failed' event name to match CheckoutController and monitoring
    if (typeof window.gtag === 'function') {
      // Send detailed failure event
      window.gtag('event', 'purchase_failed', {
        sourceScreen: 'payment failure',
        browserUserId,
        errorCode,
        errorMessage: message,
        paymentMethod,
        failureReason: message || 'Payment processing failed',
        numberOfFailedPaymentsInARow: getFailedPaymentsCount(),
        ...getPaymentTimestamps(),
        paymentProcessLatency: getPaymentProcessLatency(),
        ...getSystemInfo(),
        orderId: orderId || order,
        brandName: brand,
        order_value: orderValue,
        service_fee_amount: serviceFeeAmount,
        split_bill_enabled: splitBillEnabled === 'true',
        number_of_splits: numberOfSplits ? parseInt(numberOfSplits) : 0,
        paying_for: payingFor ? parseInt(payingFor) : 0,
        ...(splitType ? { split_type: splitType } : {}),
      });
    }
  }, [
    browserUserId,
    errorCode,
    message,
    paymentMethod,
    orderId,
    order,
    brand,
    orderValue,
    serviceFeeAmount,
    splitBillEnabled,
    numberOfSplits,
    payingFor,
    splitType,
  ]);

  return (
    <div className={styles.root}>
      <div className={styles.imgWrapper}>
        <img src={billUnpaid} alt={t('paymentFailure.paymentFailure.billUnpaid')} />
      </div>
      <div className={styles.header}>
        <h1>{t('paymentFailure.paymentFailure.paymentFailed')}</h1>
        <h2>{t('paymentFailure.paymentFailure.sorryUnsuccessful')}</h2>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default PaymentFailure;
